import type { FC } from 'react'

import { SegmentedControl } from 'cng-common/components/segmentedControl'

import styles from './OverLastYearsSelector.module.scss'

const OPTIONS = [null, 1, 2, 3, 4, 5] as const

type OverLastYearsSelectorProps = {
  value: number | null
  isDisabled?: boolean
  onSelect: (value: number | null) => void
}

const getLabel = (value: number | null) => {
  if (value === null) {
    return 'Manual'
  }

  return `${value}Y`
}

export const OverLastYearsSelector: FC<OverLastYearsSelectorProps> = ({
  value,
  isDisabled = false,
  onSelect,
}) => {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <span className={styles.label}>Auto-calculate HP brand</span>
      </div>
      <SegmentedControl
        useItemKeys
        size="small"
        rounded="rounded-full"
        backgroudn="bg-default"
        variant="veneer"
        selectedItem={value === null ? 'manual' : String(value)}
        onItemSelect={(nextValue) => onSelect(nextValue === 'manual' ? null : Number(nextValue))}
      >
        {OPTIONS.map((option) => (
          <SegmentedControl.Item
            key={option === null ? 'manual' : option}
            itemKey={option === null ? 'manual' : String(option)}
            isDisabled={isDisabled}
          >
            {getLabel(option)}
          </SegmentedControl.Item>
        ))}
      </SegmentedControl>
    </div>
  )
}
